import { useCallback, useState } from 'react'
import { BreadcrumbOverridesContext } from './breadcrumb-overrides-context'

type Overrides = Record<string, string>

export function BreadcrumbOverridesProvider({ children }: { children: React.ReactNode }) {
  const [overrides, setOverrides] = useState<Overrides>({})

  const set = useCallback((segment: string, label: string) => {
    setOverrides((prev) => (prev[segment] === label ? prev : { ...prev, [segment]: label }))
  }, [])

  const remove = useCallback((segment: string) => {
    setOverrides((prev) => {
      if (!(segment in prev)) return prev
      const next = { ...prev }
      delete next[segment]
      return next
    })
  }, [])

  return (
    <BreadcrumbOverridesContext.Provider value={{ overrides, set, remove }}>
      {children}
    </BreadcrumbOverridesContext.Provider>
  )
}
